import { storage } from "./connect";
import {
  ref,
  uploadBytesResumable,
  uploadBytes,
  getDownloadURL,
  uploadString,
} from "firebase/storage";
import { Platform } from "react-native";
import { chatErrors } from "./chats";
import axios from "axios";
export default class StorageService {
  constructor() {}

  async uploadImage(imagePath: string): Promise<string> {
    try {
      const bytes = await fetch(imagePath);
      const imageBytes = await bytes.blob();
      imagePath =
        Platform.OS === "ios" ? imagePath.replace("file://", "") : imagePath;
      const imageUrlSplited = imagePath.split("/");
      const name = imageUrlSplited[imageUrlSplited.length - 1];
      // const imageExt = imageName.split('.')[1];

      const imageRef = ref(storage, `image/${name}`);
      await uploadBytesResumable(imageRef, imageBytes);
      return await getDownloadURL(imageRef);
    } catch (err) {
      console.log(err);
      return storageErrors.systemError;
    }
  }

  async uploadImageString(value: string, ext: string): Promise<string> {
    try {
      if (!value) {
        return storageErrors.emptyFields;
      }

      const uid = Date.now();
      const imageRef = ref(storage, `image/${uid}`);
      console.log(value);
      await uploadString(imageRef, value, "data_url", { contentType: ext });
      return await getDownloadURL(imageRef);
    } catch (err) {
      console.log(err);
      return chatErrors.systemError;
    }
  }

  async uploadVideo(videoPath: string) {
    const bytes = await fetch(videoPath);
    const imageBytes = await bytes.blob();
    videoPath =
      Platform.OS === "ios" ? videoPath.replace("file://", "") : videoPath;
    const imageUrlSplited = videoPath.split("/");
    const name = imageUrlSplited[imageUrlSplited.length - 1];
    // const imageExt = imageName.split('.')[1];

    const imageRef = ref(storage, `video/${name}`);
    await uploadBytesResumable(imageRef, imageBytes);

    return await getDownloadURL(imageRef);
  }

  async uploadFile(value: string, ext: string) {
    try {
      if (!value) {
        return storageErrors.emptyFields;
      }
      const uid = Date.now();
      const docRef = ref(storage, `files/${uid}`);
      const blob = await axios.get(value, { responseType: "blob" });
  
      await uploadBytes(docRef, blob.data);
      return await getDownloadURL(docRef);
    } catch (err) {
      console.log(err);
      return chatErrors.systemError;
    }
  }
}

export const storageErrors = {
  emptyFields: "empty fields",
  systemError: "system error",
};
